<template>
  <div class="configurator-offer">

    <div class="configurator box-outline mb-2 d-none d-md-block">
      <div class="box-footer">
        <span>Bérleti díj:</span>
        <h5 v-if="calculatedPrice">{{ calculatedPrice | currency }} Ft + ÁFA / hó</h5>
        <h5 v-else>Hívjon bennünket!</h5>
        <hr>
        <div class="text-right">
          <span>Induló bérleti díj:</span>
          <h6 v-if="calculatedPrice">{{ initialPayment | currency }} Ft + ÁFA</h6>
          <h6 v-else>Hívjon bennünket!</h6>
        </div>
      </div>
    </div>

    <div class="d-none d-md-block">
      <button v-if="userLogged" type="button" class="btn btn-success btn-block mb-2" @click="onCustomOfferLoggedIn">
        EGYEDI AJÁNLATOT KÉREK
      </button>
      <button v-else type="button" class="btn btn-success btn-block mb-2" @click="$bvModal.show('configuratorCustomOfferModal')">
        EGYEDI AJÁNLATOT KÉREK
      </button>

      <button v-if="userLogged" type="button" class="btn btn-outline-secondary btn-block mb-3" @click="onEmailLoggedIn">
        <i class="fas fa-paper-plane mr-2"></i>Kérem e-mailben
      </button>
      <button v-else type="button" class="btn btn-outline-secondary btn-block mb-3" @click="$bvModal.show('configuratorEmailModal')">
        <i class="fas fa-paper-plane mr-2"></i>Kérem e-mailben
      </button>
    </div>

    <!-- Mobile-only fixed bottom bar (redesign #22/#23): price + egyedi + email, always visible. The global <sitcky-button> is hidden on this page via _custom-styles.scss. -->
    <div class="configurator-mobile-bar d-md-none">
      <div class="cmb-price">
        <small class="d-block">Bérleti díj:</small>
        <strong v-if="calculatedPrice">{{ calculatedPrice | currency }} Ft + ÁFA / hó</strong>
        <strong v-else>Hívjon!</strong>
        <small v-if="calculatedPrice" class="cmb-initial d-block">Induló bérleti díj: {{ initialPayment | currency }} Ft + ÁFA</small>
      </div>
      <div class="cmb-actions">
        <button v-if="userLogged" type="button" class="btn btn-success btn-sm btn-block mb-1" @click="onCustomOfferLoggedIn">EGYEDI AJÁNLATOT KÉREK</button>
        <button v-else type="button" class="btn btn-success btn-sm btn-block mb-1" @click="$bvModal.show('configuratorCustomOfferModal')">EGYEDI AJÁNLATOT KÉREK</button>
        <button v-if="userLogged" type="button" class="btn btn-outline-secondary btn-sm btn-block" @click="onEmailLoggedIn"><i class="fas fa-paper-plane mr-1"></i>Kérem e-mailben</button>
        <button v-else type="button" class="btn btn-outline-secondary btn-sm btn-block" @click="$bvModal.show('configuratorEmailModal')"><i class="fas fa-paper-plane mr-1"></i>Kérem e-mailben</button>
      </div>
    </div>

    <div class="offer-contact text-center d-none d-md-block">
      <a href="tel:+3618880088" class="offer-phone d-block mb-1">
        <i class="fas fa-phone mr-1"></i>Hívjon: +36 1 888 0088
      </a>
      <a href="#" @click.prevent="$bvModal.show('configuratorCallbackModal')" class="offer-callback d-block">Kérjen visszahívást!</a>
    </div>

    <!-- BIC eligibility remark, under the callback box (client R2 #1). Shown at every
         breakpoint: the block above is desktop-only, but the condition applies on mobile too. -->
    <p class="offer-bic-note" v-if="isBic">
      Kiemelt ajánlatunk legalább 2 lezárt üzleti év és 100M Ft-os bevétel és pozitív cégbírálati eredmény mellett érhető el.
    </p>

    <callback-form></callback-form>

    <!-- 3.8b: Custom offer modal (inline, replaces redirect to /megerosites) -->
    <b-modal id="configuratorCustomOfferModal" title="Egyedi ajánlatot kérek" hide-footer>
      <h5 v-if="customDone">Egyedi ajánlatkérésedet megkaptuk, hamarosan felvesszük veled a kapcsolatot!</h5>
      <b-form @submit.prevent="onCustomOffer" v-else>
        <b-form-group
          label="Cégnév *"
          label-for="co_company_name"
          :state="customOfferForm.errors.state('company_name')"
          :invalid-feedback="customOfferForm.errors.get('company_name')"
        >
          <b-form-input
            id="co_company_name"
            v-model="customOfferForm.data.company_name"
            :state="customOfferForm.errors.state('company_name')"
          />
        </b-form-group>

        <b-form-group
          label="Vezetéknév"
          label-for="co_surname"
          :state="customOfferForm.errors.state('surname')"
          :invalid-feedback="customOfferForm.errors.get('surname')"
        >
          <b-form-input
            id="co_surname"
            v-model="customOfferForm.data.surname"
            :state="customOfferForm.errors.state('surname')"
          />
        </b-form-group>

        <b-form-group
          label="Keresztnév"
          label-for="co_forename"
          :state="customOfferForm.errors.state('forename')"
          :invalid-feedback="customOfferForm.errors.get('forename')"
        >
          <b-form-input
            id="co_forename"
            v-model="customOfferForm.data.forename"
            :state="customOfferForm.errors.state('forename')"
          />
        </b-form-group>

        <b-form-group
          label="Email *"
          label-for="co_email"
          :state="customOfferForm.errors.state('email')"
          :invalid-feedback="customOfferForm.errors.get('email')"
        >
          <b-form-input
            id="co_email"
            v-model="customOfferForm.data.email"
            type="email"
            :state="customOfferForm.errors.state('email')"
          />
        </b-form-group>

        <b-form-group
          label="Mobil telefonszám"
          label-for="co_phone"
          :state="customOfferForm.errors.state('phone')"
          :invalid-feedback="customOfferForm.errors.get('phone')"
        >
          <b-form-input
            id="co_phone"
            v-model="customOfferForm.data.phone"
            type="tel"
            pattern="(\+[0-9]+|[0-9]+)"
            inputmode="numeric"
            :state="customOfferForm.errors.state('phone')"
          />
        </b-form-group>

        <b-form-group
          label="Üzenet"
          label-for="co_message"
          :state="customOfferForm.errors.state('message')"
          :invalid-feedback="customOfferForm.errors.get('message')"
        >
          <b-form-textarea
            id="co_message"
            v-model="customOfferForm.data.message"
            :state="customOfferForm.errors.state('message')"
            no-resize
            :rows="5"
            maxlength="900"
            @input="customMsgLen = ($event || '').length"
          />
          <small class="text-muted">{{ customMsgLen }} / 900 karakter</small>
        </b-form-group>

        <p>
          <small>A küldés gomb megnyomásával elfogadom az Általános Szerződési Feltételeket és az Adatvédelmi nyilatkozatot.</small>
        </p>
        <button type="submit" class="btn mt-3 btn btn-success btn-lg btn-block btn-secondary">
          <i class="fas fa-paper-plane mr-2"></i>ELKÜLD
        </button>
      </b-form>
    </b-modal>

    <!-- 3.8b: Email send modal (inline, replaces redirect to /megerosites) -->
    <b-modal id="configuratorEmailModal" title="Küldés emailben" hide-footer>
      <h5 v-if="emailDone">Kalkulációdat elküldtük emailben!</h5>
      <b-form @submit.prevent="onEmailRequest" v-else>
        <b-form-group
          label="Email"
          label-for="em_email"
          :invalid-feedback="emailForm.errors.get('email')"
          :state="emailForm.errors.state('email')"
        >
          <b-form-input
            id="em_email"
            v-model="emailForm.data.email"
            type="email"
            :state="emailForm.errors.state('email')"
            required
          />
        </b-form-group>

        <p>
          Az email cím megadásával hozzájárulok, hogy a NetLízing Zrt. emailt küldjön részemre.
        </p>
        <b-button class="mt-3 btn btn-success btn-lg btn-block" type="submit">
          <i class="fas fa-paper-plane mr-2"></i>Kérem e-mailben
        </b-button>
      </b-form>
    </b-modal>

  </div>
</template>

<style scoped>
.configurator-offer .btn {
  white-space: normal;
}

/* ponytail: sticky removed — now lives on .configurator-rail in _custom-styles.scss so the whole frame is one sticky unit */

/* Mobile fixed bottom CTA bar (#22/#23) */
.configurator-mobile-bar {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1030;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  background: #fff;
  border-top: 1px solid #e3e6ea;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, .12);
}
.configurator-mobile-bar .cmb-price {
  flex: 1 1 auto;
  background: #03679A;
  color: #fff;
  border-radius: 4px;
  padding: 5px 10px;
  line-height: 1.25;
  font-size: .8rem;
  white-space: nowrap;
}
.configurator-mobile-bar .cmb-price small {
  color: rgba(255, 255, 255, .85);
  font-size: .68rem;
}
.configurator-mobile-bar .cmb-actions {
  flex: 0 0 44%;
  max-width: 44%;
}
.configurator-mobile-bar .cmb-actions .btn {
  font-size: .78rem;
}

.offer-bic-note {
  margin-top: 0.75rem;
  margin-bottom: 0;
  font-size: 0.75rem;
  line-height: 1.35;
  color: #676868;
  text-align: center;
}
</style>

<script>
  import Vue from 'vue';
  import { Component, Prop, Watch } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';
  import VueForm from '~/form/form';
  import { trackFormSubmission, trackPurchase } from '../services/trackingService';
  import { trackQuotation } from '../services/quotationTrackingService';
  import { submitToMiniCrm } from '../services/miniCrmService';

  const configuratorModule = namespace('configurator');

  @Component
  export default class ConfiguratorOffer extends Vue {
    @configuratorModule.Getter('getCalculatedPrice') calculatedPrice;
    @configuratorModule.Getter('getInitialPayment') initialPayment;
    @configuratorModule.Action('saveLead') saveLead;
    @configuratorModule.Action('getCustomOffer') getCustomOffer;
    @configuratorModule.Action('sendLead') sendLead;

    @Prop(String) typeId;
    @Prop(Boolean) userLogged;
    @Prop(Boolean) isBic;

    syncRailSticky() {
      const rail = this.$el.closest('.configurator-rail');
      if (!rail) return;
      if (!window.matchMedia('(min-width: 992px)').matches) { rail.style.top = ''; return; }
      const margin = 24; // 1.5rem
      const railH = rail.offsetHeight;
      const vh = window.innerHeight;
      // ponytail: rail taller than viewport → pin bottom of rail to viewport bottom; otherwise pin top at margin
      rail.style.top = railH > (vh - margin) ? (vh - railH - margin) + 'px' : margin + 'px';
    }

    mounted() {
      document.body.classList.add('has-configurator-offer');
      this.$nextTick(this.syncRailSticky);
      this._railResize = () => this.syncRailSticky();
      window.addEventListener('resize', this._railResize);
    }

    beforeDestroy() {
      document.body.classList.remove('has-configurator-offer');
      window.removeEventListener('resize', this._railResize);
    }

    @Watch('calculatedPrice')
    onCalcPriceChange() { this.$nextTick(this.syncRailSticky); }

    customDone = false;
    emailDone = false;
    customMsgLen = 0;

    customOfferForm = new VueForm({
      surname: null,
      forename: null,
      company_name: null,
      email: null,
      phone: null,
      message: null,
      offer_id: null,
      terms: 1,
    });

    emailForm = new VueForm({
      email: '',
      lead_id: null,
    });

    async onCustomOffer() {
      try {
        const lead = await this.saveLead(false);
        this.customOfferForm.data.offer_id = lead.id;
        const response = await this.customOfferForm.post('/hu/regisztracio/egyediajanlat');
        await Promise.allSettled([
          trackFormSubmission('custom-offer', this.customOfferForm.data, {
            marketing: true,
            userDataConsent: true,
            transactionId: `custom-offer-${Date.now()}`,
            quotationId: lead.id,
          }),
          submitToMiniCrm('custom-offer', {
            company_name: this.customOfferForm.data.company_name,
            first_name: this.customOfferForm.data.forename,
            last_name: this.customOfferForm.data.surname,
            email: this.customOfferForm.data.email,
            phone: this.customOfferForm.data.phone,
            message: this.customOfferForm.data.message,
            gdpr: this.customOfferForm.data.terms,
            url: lead.publicUrl,
          }),
        ]);
        await trackQuotation({
          quotation_id: lead.id,
          email: this.customOfferForm.data.email || '',
          phone: this.customOfferForm.data.phone || '',
          first_name: this.customOfferForm.data.forename || '',
          last_name: this.customOfferForm.data.surname || '',
          company: this.customOfferForm.data.company_name || '',
        });
        location.href = response;
      } catch (error) {
        console.error('Error submitting custom offer:', error);
        if (error && error.user_exists === true) {
          window.location.replace('/');
        }
      }
    }

    async onEmailRequest() {
      try {
        const lead = await this.saveLead(false);
        this.emailForm.data.lead_id = lead.id;
        await this.emailForm.post('/leadssend');
        await Promise.allSettled([
          trackFormSubmission('email-request', this.emailForm.data, {
            marketing: true,
            userDataConsent: true,
            transactionId: `email-request-${Date.now()}`,
            quotationId: lead.id,
          }),
          submitToMiniCrm('email-request', {
            company_name: '',
            first_name: '',
            last_name: '',
            email: this.emailForm.data.email,
            phone: '',
            message: `Email request for lead ${lead.id}`,
            gdpr: true,
            url: lead.publicUrl,
          }),
        ]);
        await trackQuotation({
          quotation_id: lead.id,
          email: this.emailForm.data.email || '',
          phone: '',
          first_name: '',
          last_name: '',
          company: '',
        });
        location.href = '/hu/koszonjuk-ajanlatkeresed?lead=' + lead.id;
      } catch (error) {
        console.error('Error submitting email request:', error);
      }
    }

    async onCustomOfferLoggedIn() {
      try {
        const lead = await this.saveLead(false);
        await this.getCustomOffer(lead.id);
        const userData = {};
        if (window.netlizing?.user?.email) userData.email = window.netlizing.user.email;
        if (window.netlizing?.user?.phone) userData.phone = window.netlizing.user.phone;
        if (window.netlizing?.user?.id) userData.user_id = window.netlizing.user.id;
        await trackPurchase(
          { formId: 'custom-offer-request', marketing: true, userDataConsent: true, quotationId: lead.id },
          userData,
          { transaction_id: `custom-offer-${lead.id}-${Date.now()}`, currency: 'HUF', value: String(this.calculatedPrice || 0), quotationId: lead.id }
        );
        await trackQuotation({
          quotation_id: lead.id, email: userData.email || '', phone: userData.phone || '',
          first_name: '', last_name: '', company: '',
        });
        location.href = '/hu/koszonjuk-ajanlatkeresed?lead=' + lead.id;
      } catch (error) {
        console.error('Error (logged-in custom offer):', error);
      }
    }

    async onEmailLoggedIn() {
      try {
        const lead = await this.saveLead(false);
        await this.sendLead({ lead_id: lead.id, email: null }); // backend falls back to Auth user's email
        const userData = {};
        if (window.netlizing?.user?.email) userData.email = window.netlizing.user.email;
        await trackQuotation({
          quotation_id: lead.id, email: userData.email || '', phone: '',
          first_name: '', last_name: '', company: '',
        });
        this.emailDone = true;
        this.$bvModal.show('configuratorEmailModal'); // shows the "Kalkulációdat elküldtük emailben!" success state
      } catch (error) {
        console.error('Error (logged-in email):', error);
      }
    }
  }
</script>
